<script lang="ts">
  import { onMount } from 'svelte';
  import { replace, location } from 'svelte-spa-router';
  import OutgoingPaymentsList from '../../../components/admin/payments/OutgoingPaymentsList.svelte';

  let showList = false;

  onMount(() => {
    if ($location.includes('confirmation=pending')) {
      replace('/admin/pending-confirmation');
      return;
    }
    showList = true;
  });
</script>

{#if showList}
  <OutgoingPaymentsList />
{/if}
